import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { ManagementFileResponseDto } from '@domain/management-file/dtos/management-file.response.dto';

@Injectable({
    providedIn: 'root',
})
export class ManagementFileService extends UrlBuilder {
    constructor(private http: HttpClient) {
        super('management/file');
    }

    upload(request: FormData) {
        const queryUrl = `${this.getApiUrl()}/upload`;
        return this.http.post<ApiResponse<ManagementFileResponseDto>>(queryUrl, request);
    }

    show(request: RefId) {
        const { refId } = request;
        const queryUrl = `${this.getApiUrl()}/show/${refId}`;
        return this.http.get<ApiResponse<ManagementFileResponseDto>>(queryUrl);
    }

    delete(request: RefId) {
        const { refId } = request;
        const queryUrl = `${this.getApiUrl()}/${refId}`;
        return this.http.delete<ApiResponse<void>>(queryUrl);
    }

    download(request: RefId) {
        const { refId } = request;
        const queryUrl = `${this.getApiUrl()}/download/${refId}`;
        return this.http.get<ApiResponse<{ viewUrl: string }>>(queryUrl);
    }
}